import { useState } from 'react';
import { Colors, GraduationcapIcon, MagnifingglassIcon, PenIcon, QuestionmarkSmallBubbleIcon, RectanglePortraitStackIcon, RotateCircleIcon, SparkleBulletPointsIcon } from '@zep-us/zus';
import { useKeenSlider } from 'keen-slider/react';
import { useTranslation } from 'next-i18next';
import { createAutoSlidePlugin } from '@/views/build/util/createAutoSlidePlugin';
import { AI_LOADING_SLIDE_INTERVAL_MS, type AiLoadingState, buildLoadingMessages } from './aiLoadingMessages.const';
const STEP_ICONS: Record<number, typeof MagnifingglassIcon> = {
  1: MagnifingglassIcon,
  2: RotateCircleIcon,
  3: QuestionmarkSmallBubbleIcon,
  4: GraduationcapIcon,
  5: RectanglePortraitStackIcon,
  6: PenIcon,
  7: SparkleBulletPointsIcon
};
const autoSlidePlugin = createAutoSlidePlugin({
  intervalMs: AI_LOADING_SLIDE_INTERVAL_MS
});
export const AiLoadingMessage = ({
  state
}: {
  state: AiLoadingState;
}) => {
  const {
    t
  } = useTranslation(['build']);
  const [messages] = useState(() => buildLoadingMessages(state, t));
  const [sliderRef] = useKeenSlider<HTMLDivElement>({
    loop: true,
    vertical: true,
    slides: {
      perView: 1
    },
    renderMode: 'performance',
    drag: false
  }, [autoSlidePlugin]);
  return <div className="flex flex-col items-center gap-md" data-sentry-component="AiLoadingMessage" data-sentry-source-file="AiLoadingMessage.tsx">
      <div ref={sliderRef} className="h-[28px] w-full overflow-hidden" style={{
      touchAction: 'none'
    }}>
        {messages.map(({
        text,
        step
      }) => {
        const StepIcon = STEP_ICONS[step] ?? MagnifingglassIcon;
        return <div key={`${step}-${text}`} className="keen-slider__slide flex items-center justify-center gap-2xs">
              <StepIcon size="md" fill={Colors.Violet500} opacity={0.54} />
              <span className="whitespace-nowrap text-heading-md-bold gradient-text-shine" style={{
            '--gradient-shine-start': '#8478ff',
            '--gradient-shine-middle': '#3da9ff',
            '--gradient-shine-end': '#8478ff',
            animationDuration: '3s'
          } as React.CSSProperties}>
                {text}
              </span>
            </div>;
      })}
      </div>
      <p className="whitespace-nowrap text-body-lg-bold text-assistive">
        {t('build.ai.loadingTime', {
        n: 3
      })}
      </p>
    </div>;
};